<div class="base-page-container">
  <div class="text-2xl ml-6">
    FAQ For artists

  </div>

  <div>

    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="text-sm lg:text-xl font-medium flex justify-between w-full">
            <div>
              HOW DOES WUNDART WORK?
            </div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="text-xs lg:text-xl p-4">
        <p class="mb-4">Wundart is an up and coming reality grounded in quality and an immense love for anything
          creative where you, as an artist, are the focus.</p>

        <p class="font-medium mb-2">1. Apply & Subscribe</p>
        <ul class="list-disc pl-6 mb-4">
          <li>Submit your application through this link: Apply Now</li>
          <li>Our Admissions Committee will review your portfolio.</li>
          <li>Once accepted, choose the subscription plan that suits you best and unlock your artist account.</li>
        </ul>

        <p class="font-medium mb-2">For experienced artists:</p>
        <ul class="list-disc pl-6 mb-4">
          <li>If you already have existing experience you have to submit with the application form a list of all the
            galleries you have collaborated with, both past and present, and a list of exhibitions and art fairs you
            attended.</li>
        </ul>

        <p class="font-medium mb-2">For emerging artists:</p>
        <ul class="list-disc pl-6 mb-4">
          <li>If this is your first experience with the world of art sales you must undergo a quotation process of the
            artworks you upload by our team of qualified curators. Once your artworks will be quoted you can follow with
            your subscription and to the next step.</li>
        </ul>

        <p class="font-medium mb-2">2. Build Your Profile</p>
        <p class="mb-4">With the support of our Curators Team, you'll start shaping your profile — adding photos,
          personal details, and your artworks.</p>
        <p class="mb-4">Enhance your visibility by including additional images and personalized descriptions that
          capture the essence of your creations.</p>
        <p class="mb-4">This is your space to define how you present yourself, your art, and your creative world to a
          global audience.</p>

        <p class="font-medium mb-2">Process a Sale</p>
        <p class="mb-4">Our dedicated Art Advisors actively engage with collectors to showcase your work.</p>
        <p class="mb-4">When a buyer expresses interest, makes an offer, or requests more details or images, an Advisor
          will personally reach out to you to help finalize the sale and ensure a smooth transaction.</p>

        <p class="font-medium mb-2">Shipping & Logistics</p>
        <p class="mb-4">At Wundart we pride ourselves in collaborating with Mailboxes Etc., one of the leaders of the
          art shipping field.</p>
        <p class="mb-4">This collaboration ensures that the delivery process will be fully automated and in the hands of
          real professionals.</p>
        <p class="mb-4">Once a sale is confirmed, a representative from Mailboxes Etc. will contact you to guide you
          through every step of the shipping process. If you live in a larger center a courier will come directly at
          your address to make the parcel themselves, prepare the required documents, and subsequently take charge of
          the package.</p>
        <p class="mb-4"><strong>Please note:</strong> shipping costs are covered by the customer.</p>
        <p class="mb-4">You can freely choose — and update — the pickup address for your artwork at any time.</p>
        <p class="mb-4">The packaging service is only available in larger urban centres. If you live in a smaller center
          or more remote area you will be directly instructed by Mailboxes Etc. on how to handle the shipping.</p>

        <p class="font-medium mb-2">Payment</p>
        <p class="mb-4">You'll receive your payment 14 business days after the artwork is delivered to the customer.</p>
        <p class="mb-4">Transactions are processed securely via PayPal or bank transfer to the account specified in your
          artist profile.</p>

        <p class="font-medium mb-2">Continue to Grow Your Artistic Presence</p>
        <p class="mb-4">With Wundart's marketing initiatives, detailed performance insights on your audience, regular
          platform improvements, and continuous support from our Artist Care Team, you have everything you need to keep
          expanding your reach.</p>
        <p class="mb-4">Use these tools and resources to promote your art, refine your profile, and connect with an
          ever-growing global community of collectors and art lovers.</p>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="text-sm lg:text-xl font-medium flex justify-between w-full">
            <div>
              HOW DOES THE SELECTION PROCESS WORK?
            </div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="text-sm lg:text-xl p-4">
        <p class="font-medium mb-2">The Wundart Admissions Committee</p>
        <p class="mb-4">At the heart of Wundart's excellence is our Admissions Committee, a panel of distinguished art
          professionals and industry experts dedicated to upholding the platform's high standards. The members of the
          committee are qualified gallerists and curators from established realities Young Art Hunters and Almach Art
          Gallery. Each application is carefully evaluated for artistic quality, originality, and international
          potential.</p>
        <p class="mb-4">Through this selective and thoughtful process, we ensure that only the most exceptional and
          promising artists are invited to join Wundart — gaining the opportunity to showcase their work to a global
          audience and thrive in the international art market.</p>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="text-sm lg:text-xl font-medium flex justify-between w-full">
            <div>
              IS BEING REPRESENTED BY WUNDART FREE?
            </div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="text-sm lg:text-xl p-4">
        <p class="mb-4">Applying to Wundart and having your portfolio reviewed by our Admissions Committee is completely
          free.</p>
        <p class="mb-4">If selected, you'll have the opportunity to choose from our paid subscription plans, available
          with monthly or yearly billing.</p>
        <p class="mb-4">Artists without prior sales history will be asked to submit their artworks to the Committee for
          quotation — ensuring fair and accurate pricing for your pieces.</p>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="text-sm lg:text-xl font-medium flex justify-between w-full">
            <div>
              HOW MANY ARTWORKS CAN BE ON MY PROFILE?
            </div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="text-sm lg:text-xl p-4">
        <p class="font-medium mb-2">Silver Plan</p>
        <p class="mb-4">Showcase up to 10 artworks on your profile at a time — and feel free to update or replace them
          whenever you wish.</p>
        <p class="font-medium mb-2">Gold Plan</p>
        <p class="mb-4">Enjoy unlimited uploads and display your entire portfolio online, offering collectors a complete
          and evolving view of your artistic universe.</p>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="text-sm lg:text-xl font-medium flex justify-between w-full">
            <div>
              WHAT KINDS OF MEDIUM ARE ACCEPTED?
            </div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="text-sm lg:text-xl p-4">
        <p class="mb-4">We welcome a wide range of artistic mediums — from paintings and photographs to limited edition
          prints, digital artworks, and works on paper or textile.</p>
        <p class="mb-4">At the moment, we're unable to accept artworks made of glass, ceramics, jewelry, or clothing.
        </p>
        <p class="mb-4">Coming soon: sculpture submissions will also be available!</p>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="text-sm lg:text-xl font-medium flex justify-between w-full">
            <div>
              HOW WILL WUNDART PROVIDE VISIBILITY FOR MY ART?
            </div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="text-sm lg:text-xl p-4">
        <p class="mb-4">At Wundart, we're committed to helping artists gain meaningful exposure and grow their careers.
          Our constantly evolving marketing strategy ensures your artworks reach the right audience through multiple
          channels — including web search, social media, email campaigns, and more.</p>
        <p class="mb-4">Our marketing investments span paid advertising, SEO optimization, strategic partnerships, and
          press coverage, all designed to maximize visibility and sales potential.</p>
        <p class="mb-4">In addition, our Art Advisor team, personal collectors database, and smart recommendation
          algorithm work together to connect your art with collectors who share your aesthetic and interests — giving
          your work the attention it truly deserves.</p>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="text-sm lg:text-xl font-medium flex justify-between w-full">
            <div>
              CAN I STILL COLLABORATE WITH OTHER GALLERIES/PORTALS?
            </div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="text-sm lg:text-xl p-4">
        <p class="mb-4">Absolutely! At Wundart, we believe your art should reach the world in every way possible. You're
          free to collaborate with other galleries, exhibitions, and online platforms while showcasing your work with
          us.</p>
        <p class="mb-4">To ensure clarity and visibility, any artworks not currently represented by another gallery will
          be featured exclusively on Wundart — giving them a dedicated spotlight within our global community.</p>
        <p class="mb-4">Meanwhile, artworks already represented elsewhere remain non-exclusive, so you can continue
          sharing them freely.</p>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="text-sm lg:text-xl font-medium flex justify-between w-full">
            <div>
              WHO SETS THE PRICE OF MY ARTWORKS?
            </div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="text-sm lg:text-xl p-4">
        <p class="mb-4">Artists that provide a curriculum of previous experiences and sales will have full control over
          the prices of their artworks. However, totally emerging artists must submit their works for an official
          quotation process by our qualified Curatorial Team.</p>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="text-sm lg:text-xl font-medium flex justify-between w-full">
            <div>
              DOES WUNDART ACCEPT ARTISTS FROM EVERY COUNTRY?
            </div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="text-sm lg:text-xl p-4">
        <p class="mb-4">At the moment Wundart can only accept artists based in the European Union, Switzerland and
          United Kingdom, however we plan to expand Wundart's reach to many more countries and eventually globally in
          the near future.</p>
      </div>
    </mat-expansion-panel>
  </div>

  <div class="text-2xl ml-6">
    FAQ For galleries

  </div>
  <div>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="text-sm lg:text-xl font-medium flex justify-between w-full">
            <div>
              HOW DOES THE GALLERY PROFILE WORK?
            </div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="text-sm lg:text-xl p-4">
        <ul class="list-disc pl-6 space-y-2">
          <li>Your Gallery Profile is your professional showcase on Wundart.</li>
          <li>It allows you to present your represented artists under one elegant, unified space — just like managing
            your own digital exhibition.</li>
          <li>You can curate collections, manage multiple artist profiles, track visibility, and reach an international
            collector base with just a few clicks.</li>
        </ul>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="text-sm lg:text-xl font-medium flex justify-between w-full">
            <div>
              HOW DOES THE GALLERY SUBSCRIPTION WORK?
            </div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="text-sm lg:text-xl p-4">
        <ul class="list-disc pl-6 space-y-2">
          <li>A gallery subscription costs €100 per month and unlocks full access to the Wundart ecosystem — including
            advanced management tools, visibility reports, inclusion in curatorial "Drops," and eligibility for future
            gallery-only features and campaigns.</li>
          <li>You can cancel or renew anytime.</li>
        </ul>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="text-sm lg:text-xl font-medium flex justify-between w-full">
            <div>
              AS A GALLERIST HOW CAN I MANAGE MY ARTISTS ON WUNDART?
            </div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="text-sm lg:text-xl p-4">
        <ul class="list-disc pl-6 space-y-2">
          <li>Just like in a physical gallery — but easier.</li>
          <li>You'll have full control to upload, organize, and manage your artists' profiles directly.</li>
          <li>You decide which artworks are displayed, set prices, and coordinate availability exactly as you do
            offline.</li>
        </ul>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="text-sm lg:text-xl font-medium flex justify-between w-full">
            <div>
              HOW DOES THE SHIPPING WORK?
            </div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="text-sm lg:text-xl p-4">
        <ul class="list-disc pl-6 space-y-2">
          <li>Shipping is handled the same way as for individual artists, with the only difference being that the pickup
            address will be your gallery.</li>
          <li>Wundart's trusted logistics partners manage pickup, packing, insurance, and delivery to the collector —
            all tracked and insured from door to door.</li>
        </ul>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="text-sm lg:text-xl font-medium flex justify-between w-full">
            <div>
              WHICH ARTWORKS CAN I UPLOAD?
            </div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="text-sm lg:text-xl p-4">
        <ul class="list-disc pl-6 space-y-2">
          <li>You may upload any artwork currently represented or under contract with your gallery.</li>
          <li>We encourage you to highlight both your established and emerging artists — anything that reflects your
            gallery's unique curatorial voice.</li>
        </ul>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="text-sm lg:text-xl font-medium flex justify-between w-full">
            <div>
              DOES WUNDART HAVE EXCLUSIVITY OVER THE ARTWORKS I REPRESENT?
            </div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="text-sm lg:text-xl p-4">
        <ul class="list-disc pl-6 space-y-2">
          <li>No. Wundart does not require exclusivity on artworks uploaded by galleries.</li>
          <li>You remain completely free to exhibit, sell, or promote those works through your own channels or other
            platforms.</li>
        </ul>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="text-sm lg:text-xl font-medium flex justify-between w-full">
            <div>
              WHAT IS THE COMMISSION RETAINED BY WUNDART ON A SALE?
            </div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="text-sm lg:text-xl p-4">
        <p class="mb-2">The revenue split is designed to be fair and transparent:</p>
        <ul class="list-disc pl-6 space-y-2 mb-4">
          <li>60% goes to the artist,</li>
          <li>20% to the gallery,</li>
          <li>20% to Wundart for operations, marketing, and logistics.</li>
        </ul>
        <p>You'll receive automatic breakdowns for every sale directly in your dashboard.</p>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="text-sm lg:text-xl font-medium flex justify-between w-full">
            <div>
              WHAT BENEFITS DOES WUNDART OFFER GALLERIES?
            </div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="text-sm lg:text-xl p-4">
        <ul class="list-disc pl-6 space-y-2">
          <li>Global visibility for your artists and exhibitions.</li>
          <li>Direct sales to a growing international collector community.</li>
          <li>Curated exposure through Wundart events, newsletters, and social campaigns.</li>
          <li>Trusted logistics and insurance, handled end-to-end.</li>
          <li>Opportunity to discover and recruit new artists from around the world.</li>
        </ul>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="text-sm lg:text-xl font-medium flex justify-between w-full">
            <div>
              WHERE IS WUNDART CURRENTLY AVAILABLE FOR GALLERIES?
            </div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="text-sm lg:text-xl p-4">
        <p class="mb-4">Wundart is currently open to galleries based in the European Union, Switzerland, and the United
          Kingdom — with global expansion planned soon.</p>
      </div>
    </mat-expansion-panel>
  </div>


  <div class="text-2xl ml-6">
    FAQ For art lovers and collectors

  </div>
  <div>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="text-sm lg:text-xl font-medium flex justify-between w-full">
            <div>
              HOW DOES WUNDART WORK FOR A COLLECTOR?
            </div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="text-sm lg:text-xl p-4">
        <p class="mb-4">Wundart provides a highly efficient and trusted e-commerce service that connects artists and
          potential buyers. Our Curatorial Team and a highly sophisticated algorithm ensure that you always receive
          tailor-made recommendations that fit your artistic criteria.</p>
        <p class="mb-4">Thanks to our partnership with Mailboxes Etc. Wundart is able to deliver your chosen artworks
          right
          at your door with a highly efficient and trusted delivery service.</p>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="text-sm lg:text-xl font-medium flex justify-between w-full">
            <div>
              HOW DOES THE COLLECTOR PROFILE WORK?
            </div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="text-sm lg:text-xl p-4">
        <p class="mb-4">As a potential buyer or simply an art lover, once you create your "Collector" profile, you will
          be
          able to receive custom suggestions of artists and artworks based on your personal tastes, follow and contact
          artists directly, create a wishlist of artworks you wish to purchase and showcase on your profile the artworks
          you
          have already bought with Wundart in a virtual collection.</p>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="text-sm lg:text-xl font-medium flex justify-between w-full">
            <div>
              IS THE COLLECTOR PROFILE FREE?
            </div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="text-sm lg:text-xl p-4">
        <p class="mb-4">Yes, the collector profile is entirely free and includes all the aforementioned features.</p>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="text-sm lg:text-xl font-medium flex justify-between w-full">
            <div>
              HOW DOES THE PURCHASE PROCESS WORK ON WUNDART?
            </div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="text-sm lg:text-xl p-4">
        <p class="mb-4">Once you have selected your chosen artwork Wundart will guide you through the payment process.
        </p>
        <p class="mb-4">The platform accepts payments with PayPal and bank transfers.</p>
        <p class="mb-4">The artwork will be issued with a certificate of authenticity that will ensure the provenance of
          the
          artwork.</p>
        <p class="mb-4">The delivery time will be estimated before the final purchase and will be available beforehand
          to
          ensure maximum transparency. The delivery fees will be charged to the buyer and always included in the final
          price
          of the order.</p>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="text-sm lg:text-xl font-medium flex justify-between w-full">
            <div>
              IS THERE A RETURN POLICY FOR PURCHASED ITEMS?
            </div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="text-sm lg:text-xl p-4">
        <p class="mb-4">Yes, Wundart provides a refund of a purchased item within 14 days from its purchase date, after
          which the payment to the artist will be processed and it won't be possible to return the item anymore.</p>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="text-sm lg:text-xl font-medium flex justify-between w-full">
            <div>
              ARE THE SHIPPED ITEMS ENSURED?
            </div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="text-sm lg:text-xl p-4">
        <p class="mb-4">Yes, Wundart's partner Mailboxes Etc. provides a full insurance for the artworks that they take
          charge of.</p>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="text-sm lg:text-xl font-medium flex justify-between w-full">
            <div>
              CAN I CONTACT ARTISTS DIRECTLY?
            </div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="text-sm lg:text-xl p-4">
        <p class="mb-4">Yes, Wundart has an efficient built-in system of messaging that allows the artists and the
          collectors to be directly connected.</p>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="text-sm lg:text-xl font-medium flex justify-between w-full">
            <div>
              WHERE IS WUNDART AVAILABLE FOR POTENTIAL BUYERS?
            </div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="text-sm lg:text-xl p-4">
        <p class="mb-4">At the moment Wundart's services are available for all potential buyers within the European
          Union,
          Switzerland and the United Kingdom. More areas of the world will be covered very soon.</p>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="text-sm lg:text-xl font-medium flex justify-between w-full">
            <div>
              WHY SHOULD I BUY ARTWORKS WITH WUNDART?
            </div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="text-sm lg:text-xl p-4">
        <p class="mb-4">Wundart provides a high quality service that is tailored for your needs and provides
          transparency
          and efficiency in every step of the buying process. The complete insurance of the artworks, the high level and
          trusted shipping service and the possibility to contact artists directly makes for a truly unique experience
          for
          an art collector.</p>
      </div>
    </mat-expansion-panel>
  </div>
</div>